/**
 * 파일명 : com0104m.jsx
 * 설명 : 게시글등록
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 *     
 */


 /************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0104mAction } from '../../../redux/slice/com/com0104m_slice';
import { IAttachFileItemState, IRecipientItemState, IBoardDcdItemState } from '../../../redux/models/com/com0104m_model';

/* CSS */

/* AntD */
import { Input, Layout, Row, Space, Button, Descriptions, Col, Upload, Switch, Select, Table } from 'antd';
import { UploadOutlined, MailOutlined, DeleteOutlined } from '@ant-design/icons';

// Editor
import { Editor } from '@tinymce/tinymce-react';

/* 업무 */
import { IPropsCom0104M } from 'redux/models/com/com0104m_model';
import * as common from 'libs/common';
import * as commonProxy from 'libs/CommonProxy';
import parse from 'html-react-parser';


/************************************************
 * 전역변수 선언영억
 ************************************************/

const Com0104m = (props:IPropsCom0104M) => {
    let tmp = 0;
    const editorHeightDiff = 400;
    
    /* State / Reducer */
    const dispatch = useAppDispatch();
    const authBoardItems     = useAppSelector((state) => state.Frame.authBoardItems);
    const attachFileItems    = useAppSelector((state) => state.Com0104m.attachFileItems);
    const fileList           = useAppSelector((state) => state.Com0104m.fileList);
    const recipientList      = useAppSelector((state) => state.Com0104m.recipientList);
    const boardItems         = useAppSelector((state) => state.Com0104m.boardItems);
    const boardDcdList       = useAppSelector((state) => state.Com0104m.boardDcdList);
    const [isEditMode, setIsEditMode] = React.useState(false);
    const editorRef = React.useRef(null);

    const [editorHeight, setEditorHeight] = React.useState<number>(window.innerHeight - editorHeightDiff); // 기본 화면 높이에서 400px을 빼기
    const [editorKey, setEditorKey] = React.useState<number>(0);

    /* AntD */
    const { Content }  = Layout;


    /* Table Columns */
    const columnsAttachFiles = React.useCallback(() => {
        const arr:any = [
            {
                key: 'action',
                render : (record:IAttachFileItemState) =>{
                    if(record.id > 0){
                        return <Button name='btn_showDetail' className='link-button' type='link' size='small' onClick={() => common.downloadFile(record.id)}>{record.orginFileNm}</Button>
                    }else{
                        return record.orginFileNm;
                    }
                },
                align: 'left',
                width: '100px',
            },
            {
                key: 'orginFileNm',
                render : (record:IAttachFileItemState) => {
                    if (record.id < 1 || boardItems.id < 1 || isEditMode) {
                        return <Button name='btn_del' icon={<DeleteOutlined style={{color:'red'}}/>} className='link-button' size='small' onClick={() => {
                            dispatch(Com0104mAction.removeFileList(record));
                            dispatch(Com0104mAction.removeAttachFileItems(record));
                        }}></Button>
                    } else {
                        return null;
                    }
                },
                align: 'center',
                width: '5%',
            },
        ]
        return arr;
    }, [attachFileItems, isEditMode]);

    const columnsRecipientList = React.useCallback(() => {
        const arr:any = [
            {
                dataIndex: 'userId',
                key: 'userId',
                align: 'center',
                width: '15%',
            },
            {
                dataIndex: 'userNm',
                key: 'userNm',
                align: 'center',
                width: '10%',
            },
            {
                dataIndex: 'deptNm',
                key: 'deptNm',
                align: 'center',
                width: '20%',
            },
            {
                dataIndex: 'postNm',
                key: 'postNm',
                align: 'center',
                width: '20%',
            },
            {
                dataIndex: 'dutyNm',
                key: 'dutyNm',
                align: 'center',
                width: '10%',
            },
            {
                dataIndex: 'chkYn',
                key: 'chkYn',
                align: 'center',
                width: '10%',
                render: (_:string, record:IRecipientItemState) => (
                    record.chkYn === 'Y' ? '읽음' : '안읽음'
                ),
            },
            {
                dataIndex: 'lstChgDtm',
                key: 'lstChgDtm',
                align: 'center',
                width: '15%',
                render: (_:string, record:IRecipientItemState) => (
                    record.chkYn === 'Y' ? record.lstChgDtm : ''
                ),
            },
        ]
        return arr;
    }, [recipientList]);

    const fn_Search = () => {
        fn_Reset();
        if (props && props.id > 0) {
            /* 변수선언 및 셋팅 영역 */
            // 입력파라미터
            const requestData = {
                id : props.id,
            };
    
            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMR0006',
                success : (responseData:any) => {
                    const boardItems      = responseData.boardItems[0];
                    const attachFileItems = responseData.attachFileItems;
                    const boardChkItems   = responseData.boardChkItems;
    
                    setIsEditMode(false);
                    dispatch(Com0104mAction.setBoardItems(boardItems));
                    dispatch(Com0104mAction.setAttachFileItems(attachFileItems));
                    dispatch(Com0104mAction.setRecipientList(boardChkItems));
                },
            });
        } else {
            setIsEditMode(true);
        }
    }

    React.useEffect(() => {
        setBoardDcdList();
        fn_Search();

        const handleResize = () => {
            setEditorHeight(window.innerHeight - editorHeightDiff); // 화면 크기 변경 시 에디터 높이 업데이트

            let tmpKey = ++tmp;
            tmp = tmpKey;
            setEditorKey(tmpKey);
          };
      
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize); // cleanup
          };
    }, []);


    const setBoardDcdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IBoardDcdItemState[]) => {
                let arrOptions:IBoardDcdItemState[] = [];
                let authArr:any = [];

                datas.forEach((item:IBoardDcdItemState) => {
                    for (let key in authBoardItems) {
                        if (authBoardItems[key].upperMenuId === 'MCOM2021005' && authBoardItems[key].relVal) {
                            authArr.push(authBoardItems[key].relVal);
                        }
                    } 

                    if (authArr.includes(item.cd)) {
                        arrOptions.push({
                            label: item.cdNm,
                            value: item.cd
                        });
                    }
                });

                dispatch(Com0104mAction.setBoardDcdList(arrOptions));
            }

        };
        common.getComCodeList('017', option);
    }

    /** 
    * 기능 : antd dummy 업로드 흐름 관리
    * param : onSuccess
    * return : none
    */
     const dummyRequest = ({ file, onSuccess }:any) => {  	// 업로드 흐름 관리
        setTimeout(() => {
            if (fileList.filter((e:any) => {
                return e.name === file.name;
            }).length < 1) {
                onSuccess('ok');
            }
        }, 0);
    };

    /**
     * 기능 : 파일들을 Back으로 보내 업로드 한다.
     * param :
     * return : None
     */
     const requestUploadFiles = (options:any) => {
        common.uploadFile(fileList, {
            sourceDcd: '01',
            sourceId: 0,
            success: (response:any) => {
                if(typeof options.callback === 'function'){
                    options.callback(response);
                }
            },
        });
    }

    /**
     * 기능 : 선택한 파일중 done인 파일을 fileList에 추가한다.
     * param :
     * return : None
     */
     const selectFile_onChange = (info:any) => {
        switch (info.file.status) {
            case 'done':
                const grdFile = { fileNm : info.file.originFileObj.name, orginFileNm : info.file.originFileObj.name };
                dispatch(Com0104mAction.addFileList(info.file.originFileObj));
                dispatch(Com0104mAction.addAttachFileItems(grdFile));
                break;

            default:
                break;
        }
    }

    /**
     * 기능 : upload버튼의 기능 할당
     * param :
     * return : None
     */
    /* File Upload Options */
    const uploadProps = {
        onChange: selectFile_onChange,
        multiple: true,                  // 파일 다중 선택
        showUploadList: false, 		     // 업로드된 파일 리스트 보기
    };

    /**
     * 기능 : 초기화 이벤트 선언
     * param : 
     */
    const fn_Reset = () => {
        dispatch(Com0104mAction.initState());
        setIsEditMode(true);
    };

     /**
     * 기능 : 저장 이벤트 선언
     * param : 
     */
    const fn_SaveBoard = (boardStCd:string) => {
        const save = (boardStCd:string, fileItems:IAttachFileItemState[]) => {
            /* 변수선언 및 셋팅 영역 */
            let   requestData;
            if (fileItems) {
                const arrAttachFileItems: IAttachFileItemState[] = attachFileItems.filter((item:IAttachFileItemState) => {
                    return fileItems.filter((file:IAttachFileItemState) => {
                        return file.orginFileNm === item.orginFileNm;
                    }).length < 1;
                });
                requestData = { ...boardItems, fileItems: [...arrAttachFileItems, ...fileItems], boardStCd : boardStCd, boardChkItems :recipientList };
            } else {
                requestData = { ...boardItems, fileItems: attachFileItems, boardStCd : boardStCd, boardChkItems :recipientList };
            }
            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMS0002',
                success: (responseData:any) => {
                    setIsEditMode(false);
                    dispatch(Com0104mAction.setBoardItems(responseData.boardItems));
                    dispatch(Com0104mAction.setAttachFileItems(responseData.attachFileItems));

                    const param = {
                        title : '위드정보 확인',
                        contents: '정상적으로 처리되었습니다.',
                        accept: () => {
                            if(boardStCd === 'D'){
                                fn_Reset();
                            }
                        }
                    };

                    common.openAlert(param);
                },
            });
        }
        
        if (fileList && fileList.length > 0) {
            requestUploadFiles({
                callback : (data:any) => {
                    save(boardStCd, data.fileItems);
                }
            });
        } else {
            save(boardStCd, null);
        }

    };   

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
     const onClick = async (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnReset': {
                fn_Reset();
                break;
            }
            // 목록보기
            case 'btnList': {
                // const param = {
                //     menuId : 'MCOM2021006',

                // };
                const param = {
                    menuId : props.opener ? props.opener : 'MCOM2021006',
                };
                common.openPage(param);
                break;
            }
            case 'btnSave': {
                if (!boardItems.boardDcd || !boardItems.title) {
                    const param = {
                        title : '위드정보 확인',
                        contents: (!boardItems.boardDcd ? '[카테고리]' : '[제목]') + ' 은(는) 필수 입력항목입니다.',
                        accept: () => {
                            return;
                        }
                    };
                    common.openInfo(param);
                } else {
                    const param = {
                        title : '위드정보 확인',
                        contents: '게시글을 저장하시겠습니까?',
                        accept: () => {
                            fn_SaveBoard('I');
                        }
                    };
                    common.openConfirm(param);
                }

                break;
            }
            case 'btnDelete': {
                const param = {
                    title : '위드정보 확인',
                    contents: '게시글을 삭제하시겠습니까?',
                    accept: () => {
                        fn_SaveBoard('D');
                    }
                };

                common.openConfirm(param);
                
                break;
            }

            case 'btnRecipient': {
                const accept = (data:[]) => {
                    if (data && data.length > 0) {
                        dispatch(Com0104mAction.setRecipientList(data));
                    } else {
                        dispatch(Com0104mAction.setRecipientList([]));
                    }
                }
                const params:any = {};
                params.title = '수신직원 선택';
                params.popupId = 'com0103p';
                params.accept = accept;
                params.width = 1350
                params.props = {dataList : recipientList};
                common.openPopup(params);
                break;
            }
            default:
        }
    };

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Row>
                    <Col flex='auto' style={{width:'100%'}}>
                        <Descriptions bordered column={2} size='small'>
                            <Descriptions.Item label='* 카테고리' span={1} labelStyle={{width:'150px'}} style={{width:'200px'}}>
                                <Select
                                    defaultValue=''
                                    style={{width: 200}}
                                    options={boardDcdList}
                                    onChange={val => {dispatch(Com0104mAction.setBoardItems({...boardItems, boardDcd: val}))}}
                                    value={boardItems.boardDcd}

                                    /* ReadOnly 적용 */
                                    {...common.getReadonlySelectboxProps(!isEditMode)}
                                ></Select>

                            </Descriptions.Item>
                            <Descriptions.Item label='작성자' span={1} labelStyle={{width:'150px'}}>{boardItems.rgstUserNm ? boardItems.rgstUserNm : common.getUserNm()}</Descriptions.Item>
                            <Descriptions.Item label='* 제목' span={2}>
                                <Input
                                    id='inputTitle' 
                                    name='title'
                                    value={boardItems.title} 
                                    onChange={ e => dispatch(Com0104mAction.setBoardItems({...boardItems, title: e.currentTarget.value}))}
                                    readOnly={!isEditMode}
                                />
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Row>
                    <Col style={{width:'50%'}}>
                        <Space size='small' align='start'>
                            <Col style={{marginTop:5}}>
                                <Upload
                                    {...uploadProps}
                                    id='btnUpload'
                                    name='btnUpload'
                                    customRequest={dummyRequest}
                                    disabled={!isEditMode}
                                    >
                                    <Button size='small' icon={<UploadOutlined/>}>파일첨부</Button>
                                </Upload>
                            </Col>
                            <Col>
                                <Table 
                                    dataSource={attachFileItems}
                                    columns={columnsAttachFiles()}
                                    size='small'
                                    style={{width:'100%'}}
                                    scroll={{y:110}}
                                    pagination={false}
                                    showHeader={false}
                                />
                            </Col>
                        </Space>
                    </Col>
                    <Col style={{width:'50%'}}>
                        <Space size='small' align='start'>
                            <Col style={{marginTop:5}}>
                                <Button 
                                    size='small'
                                    name='btnRecipient'
                                    className='background-color-default-button'
                                    onClick={onClick}
                                    disabled={!isEditMode}
                                    icon={<MailOutlined/>}>수신자선택
                                </Button>
                                <Switch id='switchRecYn'
                                    checkedChildren='수정시재발송'
                                    unCheckedChildren='수정시미발송' 
                                    disabled={!isEditMode} 
                                    onChange={(isChecked) => {
                                        dispatch(Com0104mAction.setBoardItems({...boardItems, switchRecYn: isChecked}));
                                    }}
                                />
                            </Col>
                            <Col>
                                <Table 
                                    dataSource={recipientList}
                                    columns={columnsRecipientList()}
                                    size='small'
                                    style={{width:'100%'}}
                                    scroll={{y:110}}
                                    pagination={false}
                                    showHeader={false}
                                />
                            </Col>
                        </Space>
                    </Col>
                </Row>
                <Row style={{marginTop: 10 }}>
                    <Col style={{width:'100%'}}>
                        {!isEditMode ?
                        <div key={editorKey} style={{ height: editorHeight, display: 'flex', flexDirection: 'column', width : '100%', flex: '1 1 auto', overflowY: 'auto' }}>{parse(boardItems.cntnt)}</div> :
                        <Editor
                            key={editorKey}
                            id='editorBoard'
                            apiKey={common.editorKey}
                            onInit={(_, editor) => {
                                editorRef.current = editor;
                                document.getElementsByClassName('tox-statusbar')[0].remove();
                            }}
                            value={boardItems.cntnt}
                            init={{
                                table_cell_advtab: true,
                                resize:false,
                                toolbar_mode: 'sliding',
                                language:'ko_KR',
                                height: editorHeight,
                                menubar: false,
                                plugins: [
                                    'advlist','autolink',
                                    'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks',
                                    'fullscreen','insertdatetime','table'
                                    ],
                                toolbar: 'undo redo | fontfamily fontsize | bold italic backcolor underline | alignleft aligncenter alignright alignjustify | bullist numlist checklist outdent indent | removeformat | table',
                                content_style: 'body { font-family:굴림; font-size:12pt }',
                                font_formats:'본고딕=Noto sans KR;돋움=Dotum;돋움체=DotumChe;굴림=Gulim;굴림체=GulimChe;바탕=Batang;바탕체=BatangChe;궁서=Gungsuh;궁서체=GungsuhChe;새굴림=New Gulim;맑은 고딕=Malgun Gothic;나눔 고딕=Nanum Gothic;나눔 명조=Nanum Myoungjo'
                            }}
                            onEditorChange={
                                () => {
                                    dispatch(Com0104mAction.setBoardItems({...boardItems, cntnt: editorRef.current.getContent()}));
                                }
                            }
                            // disabled={!isEditMode}
                        />
                        }
                    </Col>
                </Row>
                <Row justify='space-around' style={{marginTop: 15 }}>
                    <Col style={{ marginRight: 15 }}>
                        <Space size='small'>
                            <Button
                                name='btnReset'
                                className='background-color-default-button'
                                onClick={fn_Reset}
                                >
                                초기화
                            </Button>
                            <Button
                                name='btnList'
                                className='background-color-default-button'
                                onClick={onClick}
                                >
                                목록보기
                            </Button>
                            {common.getEmpNo() === boardItems.rgstEmpNo ?
                            <>
                            {!isEditMode ?
                            <>
                            <Button
                                name='btnEdit'
                                className='background-color-default-button'
                                onClick={() => {
                                    setIsEditMode(true);
                                }}
                                >
                                수정
                            </Button>
                            <Button
                                name='btnDelete'
                                className='background-color-default-button'
                                onClick={(onClick)}
                                >
                                삭제
                            </Button>
                            </>
                            : null}
                            </>
                            : null}
                            {boardItems.id === 0 || isEditMode ?
                            <Button
                                name='btnSave'
                                className='background-color-primary-button'
                                onClick={onClick}
                            >
                                저장
                            </Button>
                            : null}
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0104m;